module.exports = __webpack_public_path__ + "img/实操设备.f8b71c7b.png";